export default function createAnchorId(text: string) {
  return (
    text
      ?.toLowerCase()
      .replace(/\s/g, '-')
      .replace(/['"’?]/g, '') ?? ''
  )
}
